/* eslint-disable */

import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';

import { MainLayout } from '../layouts';

import { SliceZone } from '../components';

export const query = graphql`
  query ResearchoverviewQuery($uid: String!) {
    prismic {
      researchoverview(lang: "en-us", uid: $uid) {
        _meta {
          lang
          lastPublicationDate
          type
          uid
        }
        body {
        ... on PRISMIC_ResearchoverviewBodyHerotext {
          type
            label
            primary {
              fullscreen
              large_text
              text_color
              background_color
              background_image
              display_primary_cta
              display_secondary_cta
              heading
              primary_cta_color
              primary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              primary_cta_text
              secondary_cta_link {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              secondary_cta_text
              subheading
              text_alignment
            }
        },
        ... on PRISMIC_ResearchoverviewBodyContentblock {
          type
            label
            primary {
              target_name
              background_color
              background_image
              content
              content_text_alignment
              heading
              heading_color
              image
              subheading
              subheading_color
              text_color
              wistia_id
            }
        },
        ... on PRISMIC_ResearchoverviewBodyCtaband {
          type
            label
            primary {
              text_color
              background_color
              cta_band
              cta_primary_background_color
              cta_text_primary
              cta_text_secondary
              cta_url_primary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              cta_url_secondary {
                ... on PRISMIC__ExternalLink {
                  _linkType
                  url
                }
              }
              heading
              subheading
              background_image
            }
        }}
        date
        description
        path
        title
        open_graph_image
      }
    }
  }
`;

const Researchoverview = ({ data, location }) =>
  data.prismic.researchoverview ? (
    <MainLayout location={location} layout='researchoverview'>
    <Helmet>
      <title>{(data.prismic.researchoverview.title[0] && data.prismic.researchoverview.title[0].text) || 'DigitalOcean'}</title>
      <link rel="canonical" href={data.prismic.researchoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.researchoverview.path : 'https://www.digitalocean.com' + data.prismic.researchoverview.path + '/'} />
      <meta
        name="description"
        content={
          data.prismic.researchoverview.description ||
          'Helping millions of developers easily build, test, manage, and scale applications of any size – faster than ever before.'
        }
      />
      <meta name="twitter:card" content="summary"/>
      <meta name="twitter:title" content={data.prismic.researchoverview.title[0] ? data.prismic.researchoverview.title[0].text : 'DigitalOcean'} />
      <meta name="twitter:description" content={data.prismic.researchoverview.description ? data.prismic.researchoverview.description : 'DigitalOcean'} />
      <meta name="twitter:image" property={data.prismic.researchoverview.open_graph_image ? data.prismic.researchoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
      <meta property="og:type" content="website" />
      <meta property="og:description" content={data.prismic.researchoverview.description ? data.prismic.researchoverview.description : 'DigitalOcean'} />
      <meta property="og:title" content={data.prismic.researchoverview.title[0] ? data.prismic.researchoverview.title[0].text : 'DigitalOcean'} />
      <meta property="og:url" content={data.prismic.researchoverview.path  == '/' ? 'https://www.digitalocean.com' + data.prismic.researchoverview.path : 'https://www.digitalocean.com' + data.prismic.researchoverview.path + '/'} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="600" />
      <meta property="og:image" content={data.prismic.researchoverview.open_graph_image ? data.prismic.researchoverview.open_graph_image.url : 'https://images.prismic.io/www-static/0026a57b93abe5b04413765253903472dab58e11_general-droplets_blog-v4_twitter---facebook.png?auto=compress,format'} />
    </Helmet>
      <SliceZone allSlices={data.prismic.researchoverview.body} />
    </MainLayout>
  ) : null;

Researchoverview.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Researchoverview;
